import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const SlashCircleIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.61351 9.61487L14.3865 14.3878M18.364 18.3653C14.8492 21.88 9.15076 21.88 5.63604 18.3653C2.12132 14.8506 2.12132 9.15212 5.63604 5.6374C9.15076 2.12268 14.8492 2.12268 18.364 5.6374C21.8787 9.15212 21.8787 14.8506 18.364 18.3653Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

SlashCircleIcon.displayName = 'SlashCircleIcon';
